import About from '../views/About.vue'
import Home from '../views/Home.vue'
export default [{
  path: '/',
  name: 'index',
  component: Home
}, {
  path: '/about',
  name: 'about',
  component: About
},
{
  path: '/sendcoupon',
  name: 'sendcoupon',
  component: () => import(/* webpackChunkName: "sendcoupon" */ '../views/sendCoupon/sendCoupon.vue'),
  children: [{
    path: 'sendbyphone',
    name: 'sendbyphone',
    component: () => import(/* webpackChunkName: "sendbyphone" */ '../views/sendCoupon/sendByphone.vue')
  }, {
    path: 'history',
    name: 'sendCouponHistory',
    component: () => import('../views/sendCoupon/sendCouponHistory.vue')
  }, {
    path: 'detaillist',
    name: 'sendCouponDetailList',
    component: () => import('../views/sendCoupon/sendCouponDetailList.vue')
  }]
},
{
  path: '/teammanage',
  name: 'teammanage',
  component: () => import(/* webpackChunkName: "sendcoupon" */ '../views/TeamManage/TeamManage.vue')
},
{
  path: '/purchasecoupon',
  name: 'purchasecoupon',
  component: () => import(/* webpackChunkName: "purchasecoupon" */ '../views/purchaseCoupon/index.vue'),
  children: [{
    path: 'purchase',
    name: 'purchase',
    component: () => import(/* webpackChunkName: "sendbyphone" */ '../views/purchaseCoupon/purchase.vue')
  }, {
    path: 'pay',
    name: 'pay',
    component: () => import(/* webpackChunkName: "sendbyphone" */ '../views/purchaseCoupon/pay.vue')
  }, {
    path: 'paynext',
    name: 'paynext',
    component: () => import(/* webpackChunkName: "sendbyphone" */ '../views/purchaseCoupon/payNext.vue')
  }, {
    path: 'history',
    name: 'purchaseCouponHistory',
    component: () => import(/* webpackChunkName: "purchaseCouponHistory" */ '../views/purchaseCoupon/purchaseCouponHistory.vue')
  }]
},
// {
//   path: '/recharge',
//   name: 'recharge',
//   component: () => import(/* webpackChunkName: "purchasecoupon" */ '../views/recharge/recharge.vue')
// },
{
  path: '/recharge',
  name: 'recharge',
  component: () => import(/* webpackChunkName: "purchasecoupon" */ '../views/recharge/index.vue'),
  children: [{
    path: 'recharge',
    name: 'rechargeAction',
    component: () => import('../views/recharge/recharge.vue')
  }, {
    path: 'history',
    name: 'rechargeHistory',
    component: () => import('../views/recharge/rechargeHistory.vue')
  }]
},
{
  path: '/invoice',
  name: 'invoice',
  component: () => import('../views/invoice/invoice.vue'),
  children: [{
    path: 'apply',
    name: 'applyInvoice',
    component: () => import('../views/invoice/applyInvoice.vue')
  }, {
    path: 'history',
    name: 'invoiceHistory',
    component: () => import('../views/invoice/invoiceHistory.vue')
  }]
}
]
